<template>
  <div class="dropdown float-end">
    <a @click="dropDow = !dropDow" class="dropdown-toggle arrow-none" aria-expanded="false">
      <i class="mdi mdi-dots-horizontal m-0 text-muted h5"></i>
    </a>
    <div class="dropdown-menu dropdown-menu-end" :class="{ 'show': dropDow }">
      <a class="dropdown-item" @click="copyToClipboard">
        <i class="mdi mdi-link"></i> Copiar link
      </a>
      <template v-if="userAdmin === 1">
        <a class="dropdown-item" @click="copyTask">
          <i class="mdi mdi-content-copy"></i> Duplicar
        </a>
        <a class="dropdown-item" @click="deleteTask">
          <i class="mdi mdi-delete-outline"></i> Apagar
        </a>
        <a class="dropdown-item" @click="openLogTask">
          <i class="mdi mdi-information-outline"></i> Logs
        </a>
      </template>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: {
    bucketId: {
      type: Number,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    userAdmin: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dropDow: false
    };
  },
  created() {
    //this.generatedUrl = `${window.location.origin}#${this.$route.path}/${this.bucketId}-${this.itemId}`;
    let params = {
      team: this.$route.params.team,
      alias: this.$route.params.alias,
      view: "board",
      taskId: `${this.bucketId}-${this.itemId}`
    };
    let route = this.$router.resolve({ name: "Boards", params: params });
    this.generatedUrl = `${window.location.origin}/${route.href}`;
  },
  methods: {
    ...mapActions(["showMessage"]),
    toggleDropdown() {
      this.dropDow = !this.dropDow;
    },
    handleClickOutsideMenu(event) {
      if (!this.$el.contains(event.target)) {
        this.dropDow = false;
      }
    },
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.generatedUrl);
        this.showMessage({
          title: "Copiado!",
          css: "bg-success"
        });
        this.dropDow = !this.dropDow;
      } catch (error) {
        console.error("Falha ao copiar texto: ", error);
      }
    },
    deleteTask() {
      this.$emit("deleteTask", this.bucketId, this.itemId);
      this.dropDow = !this.dropDow;
    },
    copyTask() {
      console.log("copyTask - options", this.bucketId, this.itemId);
      this.$emit("copyTask", this.bucketId, this.itemId);
      this.dropDow = !this.dropDow;
    },
    openLogTask(){
      console.log('openLogTask', this.itemId)
      this.$emit("openLogTask", this.itemId);
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutsideMenu);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutsideMenu);
  }
};
</script>
<style scoped>
.dropdown-menu.show {
  position: absolute;
  margin: 0px;
  padding: 0px;
  transform: translate3d(0px, 23px, 0px);
  top: 25px !important;
  right: -20px;
}

.dropdown-item {
  padding: 0.55rem;
}
</style>